import { __assign } from "tslib";
import { OrderStatus } from '../../types/enums/ticketing';
import { InvoiceBuilder } from './invoice-builder';
import { InvoiceItemBuilder } from './invoice-item-builder';
import { TicketBuilder } from './ticket-builder';
var OrderBuilder = /** @class */ (function () {
    function OrderBuilder() {
        this.order = {
            orderNumber: '1',
            firstName: 'FIRST NAME',
            created: new Date().toISOString(),
            tickets: [],
            ticketsPdf: '',
            invoice: {
                items: [],
                total: { amount: '1', currency: 'USD' },
                grandTotal: { amount: '1', currency: 'USD' },
            },
            checkoutForm: {
                inputValues: [],
            },
            totalPrice: { amount: '1', currency: 'USD' },
        };
    }
    OrderBuilder.prototype.withOrderNumber = function (number) {
        this.order.orderNumber = number;
        return this;
    };
    OrderBuilder.prototype.withInvoice = function (invoice) {
        this.order.invoice = invoice;
        return this;
    };
    OrderBuilder.prototype.withFirstName = function (name) {
        this.order.firstName = name;
        return this;
    };
    OrderBuilder.prototype.withLastName = function (name) {
        this.order.lastName = name;
        return this;
    };
    OrderBuilder.prototype.withEmail = function (email) {
        this.order.email = email;
        return this;
    };
    OrderBuilder.prototype.withTotal = function (total) {
        this.order.totalPrice = total;
        return this;
    };
    OrderBuilder.prototype.withTickets = function (tickets) {
        this.order.tickets = tickets;
        return this;
    };
    OrderBuilder.prototype.withCreated = function (date) {
        this.order.created = date;
        return this;
    };
    OrderBuilder.prototype.withStatus = function (status) {
        this.order.status = status;
        return this;
    };
    OrderBuilder.prototype.withCheckoutForm = function (inputs) {
        this.order.checkoutForm.inputValues = inputs;
        return this;
    };
    OrderBuilder.prototype.withEventId = function (eventId) {
        this.order.eventId = eventId;
        return this;
    };
    OrderBuilder.prototype.withTicketsPdf = function (url) {
        this.order.ticketsPdf = url;
        return this;
    };
    OrderBuilder.prototype.completed = function () {
        this.order.snapshotId = 'snapshotid';
        return this;
    };
    OrderBuilder.prototype.archived = function () {
        this.order.archived = true;
        return this;
    };
    OrderBuilder.prototype.anonymized = function () {
        this.order.anonymized = true;
        return this;
    };
    OrderBuilder.prototype.build = function () {
        return __assign({ ticketsQuantity: this.order.tickets.length }, this.order);
    };
    return OrderBuilder;
}());
export { OrderBuilder };
export var fakeOrder1 = function () {
    return new OrderBuilder()
        .withFirstName('Kent')
        .withLastName('Kentovic')
        .withOrderNumber('1')
        .withTotal({ amount: '80.50', currency: 'USD' })
        .withCreated('2016-07-12T08:20:00.000Z')
        .withStatus(OrderStatus.PENDING)
        .withTickets([
        new TicketBuilder().withId('123').build(),
        new TicketBuilder().withId('123').build(),
        new TicketBuilder().withId('123').build(),
        new TicketBuilder().withId('123').build(),
        new TicketBuilder().withId('456').build(),
        new TicketBuilder().withId('456').build(),
    ])
        .build();
};
export var fakeOrder2 = function () {
    return new OrderBuilder()
        .withFirstName('Clark')
        .withLastName('Kentovic')
        .withOrderNumber('2')
        .withCreated('2016-07-13T08:20:00.000Z')
        .withTotal({ amount: '150.50', currency: 'USD' })
        .withStatus(OrderStatus.PAID)
        .withTickets([
        new TicketBuilder().withId('333').build(),
        new TicketBuilder().withId('456').build(),
        new TicketBuilder().withId('456').build(),
    ])
        .build();
};
export var fakeDetailedOrder1 = function () {
    return new OrderBuilder()
        .withFirstName('Kent')
        .withLastName('Kentovic')
        .withEmail('kent@kentovic.com')
        .withOrderNumber('1')
        .withTotal({ amount: '80.5', currency: 'USD' })
        .withCreated('2016-07-12T08:20:00.000Z')
        .withStatus(OrderStatus.PENDING)
        .withInvoice(new InvoiceBuilder()
        .withItems([
        new InvoiceItemBuilder()
            .withId('tckdef1')
            .withPrice({ amount: '80.5', currency: 'USD' })
            .build(),
    ])
        .build())
        .withTickets([
        new TicketBuilder()
            .withId('tckdef1')
            .withPrice({ amount: '80.5', currency: 'USD' })
            .build(),
    ])
        .withCheckoutForm([
        { inputName: 'email', value: 'kent@kentovic.com', values: [] },
        { inputName: 'firstName', value: 'Kent', values: [] },
        { inputName: 'lastName', value: 'Kentovic', values: [] },
        { inputName: 'reservation', value: '9eff58e8-e87a-4312-9a18-7744c6477263', values: [] },
        { inputName: 'custom', value: 'Red', values: [] },
        { inputName: 'custom1', value: 'Green', values: [] },
        { inputName: 'custom2', value: null, values: ['Red', 'Blue'] },
        { inputName: 'address', value: null, values: ['a1', 'a2', 'a3', 'a4', 'a5'] },
        { inputName: 'date', value: '1995-11-17', values: [] },
    ])
        .build();
};
export var fakeDetailedOrder2 = function () {
    return new OrderBuilder()
        .withFirstName('Clark')
        .withLastName('Kentovic')
        .withEmail('clark@kentovic.com')
        .withOrderNumber('2')
        .withCreated('2016-07-13T08:20:00.000Z')
        .withTotal({ amount: '192.49', currency: 'USD' })
        .withStatus(OrderStatus.PAID)
        .withTickets([
        new TicketBuilder()
            .withTicketNumber('2001')
            .withId('tckdef1')
            .withPrice({ amount: '20.5', currency: 'USD' })
            .build(),
        new TicketBuilder()
            .withTicketNumber('2002')
            .withId('tckdef1')
            .withPrice({ amount: '20.5', currency: 'USD' })
            .build(),
        new TicketBuilder()
            .withTicketNumber('2003')
            .withId('tckdef1')
            .withPrice({ amount: '20.5', currency: 'USD' })
            .build(),
        new TicketBuilder()
            .withTicketNumber('2004')
            .withId('tckdef2')
            .withPrice({ amount: '130.99', currency: 'USD' })
            .build(),
    ])
        .build();
};
//# sourceMappingURL=order-builder.js.map